import http from '@/services/http.js';

export const fetchTaskStatus = async (client_id) => {
  const data = await http.get(
    `/videoapi/automationFlow/taskStatus/${client_id}`
  );
  return data.data;
};

export const fetchAutomationTaskResult = async (client_id) => {
  const response = await http.get(
    `/videoapi/automationFlow/taskResult/${client_id}`
  );
  return response.data;
};

export const fetchImageTaskResult = async (batch_id) => {
  const data = await http.get(
    `/videoapi/automationFlow//manual-check/${batch_id}`
  );
  return data.data;
};

export const fetchAudioTaskResult = async (batch_id) => {
  const data = await http.get(
    `/videoapi/automationFlow/audio-check/${batch_id}`
  );
  return data.data;
};
